import { useV2ListProjectVariablesQuery } from "@generated";
import { ProjectVariable } from "../types/Contact";

const useListContactProjectVariables = () => {
  const { data, isLoading } = useV2ListProjectVariablesQuery({
    filter: { "variable-context": "project_contact" },
  });

  const variables: ProjectVariable[] =
    data?.data?.map((pv: any) => {
      const attr = pv.attributes;
      return {
        name: attr?.name || "",
        label: attr?.label || "",
        variable_type: attr?.["variable-type"],
        minimum: attr?.minimum,
        maximum: attr?.maximum,
        required: attr?.required ?? false,
        select_options: attr?.["select-options"] || [],
        position: attr?.position,
        context: attr?.context,
        uuid: attr?.uuid,
        value: "",
      };
    }) || [];

  return { variables, variablesLoading: isLoading };
};

export default useListContactProjectVariables;
